import { gql } from '@apollo/client'

export const GENERATE_TARGET_REPORT_REQUEST = gql`
  mutation GenerateTargetReportRequest($companyId: HashedId!, $country: Country!) {
    generateTargetReportRequest(companyId: $companyId, country: $country) {
      generationResult
      createTargetReport
    }
  }
`

export const GENERATE_RANKING_REPORT = gql`
  mutation GenerateRankingReport($reportId: HashedId!) {
    generateRankingReport(reportId: $reportId)
  }
`

export const CREATE_ZIP_WITH_SELECTED_RANKING_REPORTS = gql`
  mutation CreateZipWithSelectedRankingReport($reportIds: [HashedId!]!) {
    createZipWithSelectedRankingReports(reportIds: $reportIds)
  }
`
